import { getImageSource } from "../../../../helpers/getImageSource";
import { getContentfulImageUrl } from "../../../../helpers/images/getContentfulImageUrl";
import { getStoryblokImageUrl } from "../../../../helpers/images/getStoryblokImageUrl";
import classNames from "classnames/bind";
import { ImgHTMLAttributes, ReactNode } from "react";
import styles from "./PhaseSideImageColumns.module.css";

const cx = classNames.bind(styles);

export function PhaseSideImageColumns({
  items,
}: {
  items: Array<{
    headline: string | null;
    image: {
      description: string | null;
      url: string | null;
    } | null;
    bodyText: ReactNode | null;
  }>;
}) {
  return (
    <div className={cx("container")}>
      {items.map((panel, index) => {
        const imageUrl = panel.image?.url;
        const imageSource = imageUrl ? getImageSource(imageUrl) : null;

        return (
          <div key={index} className={cx("column")}>
            {panel.image?.url &&
              (() => {
                const imageUrl = panel.image.url;

                const commonImageAttributes: ImgHTMLAttributes<HTMLImageElement> =
                  {
                    className: cx("image"),
                    alt: panel.image?.description ?? undefined,
                    sizes:
                      "(width >= 1000px) 140px, (width >= 768px) 170px, 300px",
                  };

                const widths = [140, 170, 300].flatMap((width) => [
                  width,
                  width * 1.5,
                  width * 2,
                ]);

                switch (imageSource) {
                  case "contentful":
                    return (
                      <img
                        src={getContentfulImageUrl(imageUrl, {})}
                        srcSet={widths
                          .map((width) => {
                            const src = getContentfulImageUrl(imageUrl, {
                              width,
                              fm: "webp",
                            });
                            return `${src} ${width}w`;
                          })
                          .join(", ")}
                        {...commonImageAttributes}
                      />
                    );
                  case "storyblok":
                    return (
                      <img
                        {...commonImageAttributes}
                        src={getStoryblokImageUrl(imageUrl)}
                        srcSet={widths
                          .map((width) => {
                            const src = getStoryblokImageUrl(imageUrl, {
                              width,
                              format: "webp",
                            });
                            return `${src} ${width}w`;
                          })
                          .join(", ")}
                      />
                    );
                  default:
                    return <img src={imageUrl} {...commonImageAttributes} />;
                }
              })()}
            <div className={cx("content-wrapper")}>
              <h3 className={cx("headline")}>{panel.headline}</h3>
              {typeof panel.bodyText === "string" ? (
                <div
                  style={{ display: "contents" }}
                  dangerouslySetInnerHTML={{
                    __html: panel.bodyText,
                  }}
                />
              ) : (
                panel.bodyText
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
